module.exports = __webpack_public_path__ + "./kit/docs/img/kit-logo.ad83eca3063ab2561f2273bace702f65.svg";